import { ChangeDetectorRef, Component, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { UserService } from 'src/app/core/common-services/user.services';
import { AuthenticationService } from 'src/app/core/data-services/authentication.service';
import { SentryService } from 'src/app/core/common-services/sentry.service';
import { SessionTimeoutService } from 'src/app/core/common-services/session-timeout.service';
import { ConnectionService } from 'src/app/core/common-services/connection.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'JARI-SOLUTIONS';
  currentSystemLanguage: string = 'en-US';
  style: boolean = false;
  isOffline: boolean = false;

  private routerSubscription?: Subscription;
  private connectionSubscription?: Subscription;

  constructor(
    public router: Router,
    private userService: UserService,
    private _elementRef: ElementRef,
    private sentryService: SentryService,
    private sessionTimeoutService: SessionTimeoutService,
    private authenticationService: AuthenticationService,
    private connectionService: ConnectionService
  ) {
  }

  logout() {
    this.authenticationService.logout().subscribe({
      next: () => {
        this.userService.logout();
      },
      error: () => {
        this.userService.logout();
      }
    });
  }
  
  ngOnInit(): void {
    this._elementRef.nativeElement.removeAttribute("ng-version");

    // TODO: Remove after verifying Sentry is working on all environments
    this.triggerSentryTestError();

    this.routerSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      if (this.isLoggedIn()) {
        this.sessionTimeoutService.startTimer();
      } else {
        this.sessionTimeoutService.stopTimer();
      }
    });

    this.connectionSubscription = this.connectionService.isOnline$.subscribe(
      (isOnline) => {
        this.isOffline = !isOnline;
      }
    );
  }

  /**
   * Sends a test exception and message to Sentry to verify the integration is working.
   * Remove this method once Sentry dashboard shows the test events.
   */
  private triggerSentryTestError(): void {
    try {
      throw new Error('Sentry Test Error: Verifying Sentry integration is working on Dashboard');
    } catch (error) {
      this.sentryService.captureException(error as Error, {
        testEvent: true,
        triggeredAt: new Date().toISOString(),
        purpose: 'Verify Sentry integration across all environments',
      });
    }
    this.sentryService.captureMessage(
      'Sentry Test Message: Dashboard integration verified',
      'info'
    );
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    if (this.connectionSubscription) {
      this.connectionSubscription.unsubscribe();
    }
  }

  get offlineMessage(): string {
    return this.connectionService.getNoInternetMessage();
  }

  isLoggedIn() {
    return this.userService.currentUserCredantials!=undefined&&this.userService.isLoggedIn();
  }

  
  close() {
    document.getElementById('errorMsg')!.innerHTML = '';
    if (document.getElementsByClassName('error_toaster_show').length > 0)
      document
        .getElementsByClassName('error_toaster_show')[0]
        .setAttribute('class', 'error_toaster');

    document.getElementById('successMsg')!.innerHTML = '';
    if (document.getElementsByClassName('success_toaster_show').length > 0)
      document
        .getElementsByClassName('success_toaster_show')[0]
        .setAttribute('class', 'success_toaster');

    document.getElementById('warningMsg')!.innerHTML = '';
    if (document.getElementsByClassName('warning_toaster_show').length > 0)
      document
        .getElementsByClassName('warning_toaster_show')[0]
        .setAttribute('class', 'warning_toaster');

    document.getElementById('infoMsg')!.innerHTML = '';
    if (document.getElementsByClassName('info_toaster_show').length > 0)
      document
        .getElementsByClassName('info_toaster_show')[0]
        .setAttribute('class', 'info_toaster');
  }
}
